import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { Questionnaire } from '../models/questionnaire';
import { finalize } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class QuestionnaireService {
  private loading = new BehaviorSubject(false);
  readonly loading$ = this.loading.asObservable();

  constructor(private httpClient: HttpClient) {
  }

  create(questionnaire: Questionnaire): Observable<{questionnaireId:string}> {
    this.loading.next(true);
    return this.httpClient.post<{questionnaireId:string}>('/portal/questionnaires', questionnaire)
      .pipe(finalize(() => this.loading.next(false)));
  }

  duplicate(id: string): Observable<{questionnaireId:string}> {
    this.loading.next(true);
    return this.httpClient.post<{questionnaireId:string}>(`/portal/questionnaires/${id}/duplicate`, null)
      .pipe(finalize(() => this.loading.next(false)));
  }

  update(id: string, questionnaire: Questionnaire): Observable<void> {
    this.loading.next(true);
    return this.httpClient.put<void>(`/portal/questionnaires/${id}`, questionnaire)
      .pipe(finalize(() => this.loading.next(false)));
  }

  getAll(): Observable<Questionnaire[]> {
    this.loading.next(true);
    return this.httpClient.get<Questionnaire[]>(`/portal/questionnaires`)
      .pipe(finalize(() => this.loading.next(false)));
  }

  get(id: string): Observable<Questionnaire> {
    this.loading.next(true);
    return this.httpClient.get<Questionnaire>(`/portal/questionnaires/${id}`)
      .pipe(finalize(() => this.loading.next(false)));
  }

  delete(id: string): Observable<void> {
    this.loading.next(true);
    return this.httpClient.delete<void>(`/portal/questionnaires/${id}`)
      .pipe(finalize(() => this.loading.next(false)));
  }

  getPdfByAttachmentId(attachmentId: string, lang: string): Observable<Blob> {
    this.loading.next(true);
    const headers = new HttpHeaders().set('content-type', 'application/pdf');
    return this.httpClient.get(`/portal/questionnaires/result/${attachmentId}?lang=${lang}`, { headers, responseType: 'blob' })
      .pipe(finalize(() => this.loading.next(false)));
  }
}
